export default __webpack_public_path__ + "static/media/edit_channel_icon.301863ce.svg";